/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Button,
  Grid,
} from 'antd';

import {
  ArrowLeftOutlined,
  SaveOutlined,

} from '@ant-design/icons';

const ModalFechaObservacionControls = ({
  onSave, onCancel, loading, label,
}) => {
  const screens = Grid.useBreakpoint();
  const controls = (
    <Row className="form-submit-controls">
      <Button
        type="link"
        onClick={onCancel}
        disabled={loading}
      >
        <ArrowLeftOutlined />
        {screens.md && 'Cancelar'}
      </Button>
      <Button
        type="link"
        onClick={onSave}
        disabled={loading}
        style={{ marginLeft: 10 }}
      >
        <SaveOutlined />
        {screens.md && 'Guardar'}
      </Button>
    </Row>
  );

  return (
    <>
      {label}
      {controls}
    </>
  );
};

ModalFechaObservacionControls.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  label: PropTypes.string,
};

ModalFechaObservacionControls.defaultProps = {
  loading: false,
  label: null,
};

export default ModalFechaObservacionControls;
